import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

//Componentes auxiliares:
import PasswordResetModal from './PasswordResetModal';

//Scripts auxiliares:
import { timeoutFetch, registerAuditProcess } from '../../../tools/scripts/customFetching';

class LoginForm extends React.Component {

    constructor() {
        super();

        //Posible view modes: checkingLS, defaultLogin, loadingApp, 
        this.state = {
            viewMode: "checkingLS",
            isPasswordResetModalOpen: false,
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.getLoginForm()}
                {this.getLoadingAppScreen()}
                {this.getCheckingLocalStorageScreen()}

                <PasswordResetModal
                    modalToggle={this.modalToggle}
                    isOpen={this.state.isPasswordResetModalOpen} />
            </React.Fragment>
        );
    }

    componentDidMount(){
        this.loadLastLoggedUserFromLocalStorage(this.props);
    }

    //Métodos para renderizado:
    getCheckingLocalStorageScreen = () => {
        if (this.state.viewMode === "checkingLS") {
            return (
                <p>Cargando...</p>
            );
        }
    }

    getLoadingAppScreen = () => {
        if (this.state.viewMode === "loadingApp") {
            const lastLoggedUser = JSON.parse(localStorage.getItem("lastLoggedUser"));

            return (
                <div style={{ textAlign: "center", paddingTop: "5vh", paddingBottom: 0 }}>
                    <p>Bienvenido de vuelta</p>
                    <p><b>{lastLoggedUser.email}</b></p>
                    <p>En un momento, serás redirigido a la aplicación principal</p>
                </div>
            );
        }
    }

    getLoginForm = () => {
        if (this.state.viewMode === "defaultLogin") {
            return (
                <form className={this.props.classes.form}
                    onSubmit={(e) => { this.loginFormSubmit(e, this.props) }}>
                    <TextField
                        // value="admin@fitideas.co"
                        style={this.props.customFontStyle}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Correo electrónico"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        type="email"/>

                    <TextField
                        // value="Salni5456"
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        id="password"
                        autoComplete="current-password" />

                    <p style={{ marginBottom: 0, marginLeft: 15, color: "red" }} id="labelCredencialesIncorrectas" hidden>
                        Credenciales incorrectas...
                                </p>

                    <p style={{ marginBottom: 0, marginLeft: 15, color: "red" }} id="labelErrorDelSistema" hidden>
                        Error del sistema. Comunícate con el administrador...
                                </p>

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={this.props.classes.submit}>
                        Iniciar sesión
                                </Button>

                    <Typography variant="body2" color="textSecondary" align="right"
                        style={{ fontSize: 10, paddingRight: 15 }}>
                        <Link color="inherit" href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.modalToggle();
                            }}>
                            <b>Olvidé mi contraseña</b>
                        </Link>
                    </Typography>
                </form>
            );
        }
    }

    //Métodos operativos:
    getUserInfoAndLogin = (loggedUser, props, autoLogin = false) => {
        timeoutFetch(process.env.REACT_APP_API_URL + "/users/" + loggedUser.user_id, {
            method: 'get',
            headers: { 'Authorization': 'Token ' + loggedUser.token }
        }, 5000)
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json().then(userInfo => {
                            let timeout = 0;
                            if (autoLogin) { timeout = this.props.loginWaitTime; }
                            this.setState({ viewMode: "loadingApp" });

                            setTimeout(() => {
                                if (!this.props.isUserLogged) {
                                    registerAuditProcess({ ...props, activeUser: { ...userInfo, authToken: loggedUser.token } }, {
                                        "event_type": "USER_LOGIN",
                                        "description": "El usuario <b>inició sesión</b> en la plataforma"
                                    });

                                    this.props.loginUser({ ...userInfo, authToken: loggedUser.token });
                                }

                                let lastVisitedRoute = JSON.parse(localStorage.getItem('lastVisitedRoute'));
                                (lastVisitedRoute) ? this.props.history.push(lastVisitedRoute) : this.props.history.push('/admin/sources');
                            }, timeout);

                        });
                        break;

                    default:
                        localStorage.removeItem('lastLoggedUser');
                        this.setState({ viewMode: "defaultLogin" });
                        try { document.getElementById('labelCredencialesIncorrectas').hidden = false; }
                        catch (error) { window.location.reload(); }
                        break;
                }
            })
            .catch(error => {
                console.log(error);

                localStorage.removeItem('lastLoggedUser');
                try { document.getElementById('labelCredencialesIncorrectas').hidden = false; }
                catch (error) { window.location.reload(); }
            });
    }

    loadLastLoggedUserFromLocalStorage = (props) => {
        let lastLoggedUser = JSON.parse(localStorage.getItem("lastLoggedUser"));
        if (lastLoggedUser !== null) { this.getUserInfoAndLogin(lastLoggedUser, props, true); }
        else { this.setState({ viewMode: "defaultLogin" }); }
    }

    loginFormSubmit = (e, props) => {
        e.preventDefault();
        document.body.style.cursor = "wait";
        document.getElementById('labelErrorDelSistema').hidden = true;
        document.getElementById('labelCredencialesIncorrectas').hidden = true;

        timeoutFetch(process.env.REACT_APP_API_URL + "/generateAuthToken/", {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username: e.target.email.value, password: e.target.password.value })
        }, 5000)
            .then(serverResponse => {
                document.body.style.cursor = "default";
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json().then(loggedUser => {
                            localStorage.setItem("lastLoggedUser", JSON.stringify(loggedUser));
                            this.getUserInfoAndLogin(loggedUser, props);
                        });
                        break;

                    case 400:
                        // console.log('Credenciales incorrectas');
                        document.body.style.cursor = "default";
                        document.getElementById('labelCredencialesIncorrectas').hidden = false;
                        break;

                    default:
                        console.log('Error del sistema');
                        document.body.style.cursor = "default";
                        document.getElementById('labelErrorDelSistema').hidden = false;
                        break;
                }

            })
            .catch(error => {
                console.log(error);
                document.body.style.cursor = "default";
                document.getElementById('labelErrorDelSistema').hidden = false;
            });
    }

    modalToggle = ()=>{
        this.setState({isPasswordResetModalOpen: !this.state.isPasswordResetModalOpen});
    }
}

const mapdispatchToProps = dispatch => {
    return {
        loginUser: (newActiveUser) => {
            dispatch({ type: "changeActiveUser", newActiveUser: newActiveUser, isUserLogged: true })
        }
    };
};

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        isUserLogged: state.mainReducer.isUserLogged,
        loginWaitTime: state.mainReducer.loginWaitTime,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(withRouter(LoginForm));